/**
 * Presents the blocking Shipping capacity message. The configured maximum is
 * supplied by merchant preferences; closing returns control to the item flow.
 */

import { BorderedButton } from "@/components/button/borderedButton";
import { RegularModal } from "@/components/modals/modals";
import { useTranslations } from "next-intl";
import { useId } from "react";

interface ShippingCartFullModalProps {
  isOpen: boolean;
  maxItems: number;
  merchantColor: string;
  onRequestClose: () => void;
}

export const ShippingCartFullModal = ({
  isOpen,
  maxItems,
  merchantColor,
  onRequestClose,
}: ShippingCartFullModalProps) => {
  const t = useTranslations("ShippingCartFullModal");
  const titleId = useId();
  const descriptionId = useId();
  const closeButtonId = useId();

  return (
    <RegularModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="bg-opacity-50"
      contentClassName="bg-white rounded-lg shadow-lg w-[100%] max-w-md mx-auto overflow-hidden"
      aria={{ labelledby: titleId, describedby: descriptionId }}
      focusElementId={closeButtonId}
      closeModalLabel={t("closeIconLabel")}
    >
      <div className="px-5 pt-5 pb-4">
        <h2 id={titleId} className="text-xl font-semibold pr-10">
          {t("title")}
        </h2>
        <p id={descriptionId} className="mt-4 text-sm leading-5">
          {t("message", { maxItems })}
        </p>
        <div className="flex justify-end mt-8">
          <BorderedButton
            id={closeButtonId}
            onClick={onRequestClose}
            style={{ color: merchantColor, borderColor: merchantColor }}
            className="!flex-none w-[100px] h-12 justify-center rounded-lg px-6 py-3 text-base font-medium whitespace-nowrap"
            aria-label={t("close")}
          >
            {t("close")}
          </BorderedButton>
        </div>
      </div>
    </RegularModal>
  );
};
